import React, { Component } from 'react';
import { MultiDropdownList } from '@appbaseio/reactivesearch';
import MultiDropdownListWithFocus from './MultiDropdownListWithFocus';

class MemoOut extends Component {
  render() {
    return (
      <div className="memo-out form-field-wrap ">
        <MultiDropdownList
          className="form-field unknown"
          title="Memo Cust"
          componentId="MemoOut"
          dataField={"MemoOutCustomer.keyword"}
          size={1000}
          showCount={false}
          showSearch={true}
          sortBy="asc"
          renderListItem={label => (
            <div>{label !== "NULL" ? label : "None"}</div>
          )}
        />
      </div>
    );
  }
}

export default MultiDropdownListWithFocus(MemoOut);